import { render, staticRenderFns } from "./ModalCompostExchange.vue?vue&type=template&id=ce96a922&scoped=true&"
import script from "./ModalCompostExchange.vue?vue&type=script&lang=js&"
export * from "./ModalCompostExchange.vue?vue&type=script&lang=js&"
import style0 from "./ModalCompostExchange.vue?vue&type=style&index=0&id=ce96a922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce96a922",
  null
  
)

export default component.exports